<div class="istoric-programari-wrapper">
    <div class="section-header" (click)="toggleCollapse()">
        <div class="header-left">
            <i class="fa-solid fa-clipboard-list"></i>
            <span class="header-title">Istoric programari cetatean</span>
            <span class="badge badge-count" *ngIf="!isLoading && total > 0">{{ total }}</span>
        </div>
        <div class="header-right">
            <i class="fa-solid" [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </div>
    </div>

    <div class="section-body" *ngIf="!isCollapsed">
        <!-- Loading -->
        <div class="text-center p-3" *ngIf="isLoading">
            <mat-spinner diameter="30" class="mx-auto"></mat-spinner>
            <small class="text-muted mt-1 d-block">Se incarca istoricul...</small>
        </div>

        <div *ngIf="!isLoading">
            <!-- Match info -->
            <div class="match-info" *ngIf="total > 0">
                <small class="text-muted">
                    Cautare pe:
                    <span *ngIf="matchInfo.cnp" class="badge badge-match">CNP</span>
                    <span *ngIf="matchInfo.telefon" class="badge badge-match">Telefon</span>
                    <span *ngIf="matchInfo.email" class="badge badge-match">Email</span>
                </small>
                <small class="text-muted ms-2">
                    Total: {{ total }}
                    ({{ pastAppointments.length }} trecute, {{ futureAppointments.length }} viitoare)
                </small>
            </div>

            <!-- Warning banner -->
            <div class="alert alert-warning d-flex align-items-center py-2 px-3 mt-2 mb-2" *ngIf="total > 2">
                <i class="fa-solid fa-triangle-exclamation me-2"></i>
                <strong>ATENTIE: {{ total }} programari identificate pe aceleasi date de contact!</strong>
            </div>

            <!-- Empty state -->
            <div class="empty-state text-center p-3" *ngIf="total === 0">
                <i class="fa-solid fa-check-circle text-success"></i>
                <span class="text-muted ms-2">Nu au fost identificate alte programari pentru acest cetatean.</span>
            </div>

            <!-- Tabs Viitoare / Trecute -->
            <mat-tab-group *ngIf="total > 0" class="istoric-tabs" animationDuration="200ms">
                <!-- Tab Viitoare -->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-label-future">
                            <i class="fa-solid fa-calendar-check me-1"></i>
                            Viitoare ({{ futureAppointments.length }})
                        </span>
                    </ng-template>

                    <div class="tab-content-area">
                        <div *ngIf="futureAppointments.length === 0" class="text-center p-3">
                            <small class="text-muted">Nicio programare viitoare.</small>
                        </div>

                        <div *ngFor="let apt of pagedFuture"
                             class="appointment-card" [ngClass]="getCardBorderClass(apt)">
                            <div class="card-header-row">
                                <span class="appointment-id">#{{ apt.id }}</span>
                                <span class="badge status-badge" [ngStyle]="{
                                    'background-color': apt.status_bg_color,
                                    'color': apt.status_color
                                }">{{ apt.status_name }}</span>
                                <span class="badge badge-source ms-1">{{ getSourceLabel(apt.source) }}</span>
                                <span class="ms-auto">
                                    <button class="btn btn-sm btn-outline-primary btn-open"
                                            (click)="openAppointment(apt.id)" title="Deschide in tab nou">
                                        <i class="fa-solid fa-up-right-from-square"></i>
                                        <span class="ms-1">Deschide</span>
                                    </button>
                                </span>
                            </div>
                            <div class="card-body-row">
                                <div class="info-line" *ngIf="apt.slot_date">
                                    <i class="fa-regular fa-calendar"></i>
                                    <span>{{ formatSlotDate(apt.slot_date) }}, {{ apt.slot_time_from }}<span *ngIf="apt.slot_time_end"> - {{ apt.slot_time_end }}</span></span>
                                </div>
                                <div class="info-line" *ngIf="apt.slot_locatie || apt.slot_serviciu">
                                    <i class="fa-solid fa-location-dot"></i>
                                    <span>
                                        <span *ngIf="apt.slot_locatie">{{ apt.slot_locatie }}</span>
                                        <span *ngIf="apt.slot_locatie && apt.slot_serviciu"> &gt; </span>
                                        <span *ngIf="apt.slot_serviciu">{{ apt.slot_serviciu }}</span>
                                    </span>
                                </div>
                                <div class="info-line">
                                    <i class="fa-solid fa-user"></i>
                                    <span>
                                        {{ apt.cetatean_name }}
                                        <span class="text-muted" *ngIf="apt.cetatean_cnp"> | CNP: {{ apt.cetatean_cnp }}</span>
                                        <span class="text-muted" *ngIf="apt.cetatean_telefon"> | Tel: {{ apt.cetatean_telefon }}</span>
                                    </span>
                                </div>
                                <div class="info-line" *ngIf="apt.presence_status">
                                    <i class="fa-solid" [ngClass]="apt.presence_status === 1 ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"></i>
                                    <span>{{ getPresenceLabel(apt.presence_status) }}</span>
                                </div>
                            </div>
                            <div class="card-footer-row">
                                <small class="text-muted">Creat: {{ apt.created_at }}</small>
                            </div>
                        </div>

                        <!-- Paginare viitoare -->
                        <div class="pagination-controls" *ngIf="futureTotalPages > 1">
                            <button class="btn btn-sm btn-outline-secondary" (click)="prevFuturePage()" [disabled]="futurePage === 0">
                                <i class="fa-solid fa-chevron-left"></i>
                            </button>
                            <span class="page-indicator">{{ futurePage + 1 }} / {{ futureTotalPages }}</span>
                            <button class="btn btn-sm btn-outline-secondary" (click)="nextFuturePage()" [disabled]="futurePage >= futureTotalPages - 1">
                                <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </mat-tab>

                <!-- Tab Trecute -->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-label-past">
                            <i class="fa-solid fa-clock-rotate-left me-1"></i>
                            Trecute ({{ pastAppointments.length }})
                        </span>
                    </ng-template>

                    <div class="tab-content-area">
                        <div *ngIf="pastAppointments.length === 0" class="text-center p-3">
                            <small class="text-muted">Nicio programare trecuta.</small>
                        </div>

                        <div *ngFor="let apt of pagedPast"
                             class="appointment-card" [ngClass]="getCardBorderClass(apt)">
                            <div class="card-header-row">
                                <span class="appointment-id">#{{ apt.id }}</span>
                                <span class="badge status-badge" [ngStyle]="{
                                    'background-color': apt.status_bg_color,
                                    'color': apt.status_color
                                }">{{ apt.status_name }}</span>
                                <span class="badge badge-source ms-1">{{ getSourceLabel(apt.source) }}</span>
                                <span *ngIf="apt.presence_status" class="badge ms-1"
                                      [ngClass]="apt.presence_status === 1 ? 'badge-present' : 'badge-absent'">
                                    {{ getPresenceLabel(apt.presence_status) }}
                                </span>
                                <span class="ms-auto">
                                    <button class="btn btn-sm btn-outline-primary btn-open"
                                            (click)="openAppointment(apt.id)" title="Deschide in tab nou">
                                        <i class="fa-solid fa-up-right-from-square"></i>
                                        <span class="ms-1">Deschide</span>
                                    </button>
                                </span>
                            </div>
                            <div class="card-body-row">
                                <div class="info-line" *ngIf="apt.slot_date">
                                    <i class="fa-regular fa-calendar"></i>
                                    <span>{{ formatSlotDate(apt.slot_date) }}, {{ apt.slot_time_from }}<span *ngIf="apt.slot_time_end"> - {{ apt.slot_time_end }}</span></span>
                                </div>
                                <div class="info-line" *ngIf="apt.slot_locatie || apt.slot_serviciu">
                                    <i class="fa-solid fa-location-dot"></i>
                                    <span>
                                        <span *ngIf="apt.slot_locatie">{{ apt.slot_locatie }}</span>
                                        <span *ngIf="apt.slot_locatie && apt.slot_serviciu"> &gt; </span>
                                        <span *ngIf="apt.slot_serviciu">{{ apt.slot_serviciu }}</span>
                                    </span>
                                </div>
                                <div class="info-line">
                                    <i class="fa-solid fa-user"></i>
                                    <span>
                                        {{ apt.cetatean_name }}
                                        <span class="text-muted" *ngIf="apt.cetatean_cnp"> | CNP: {{ apt.cetatean_cnp }}</span>
                                        <span class="text-muted" *ngIf="apt.cetatean_telefon"> | Tel: {{ apt.cetatean_telefon }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="card-footer-row">
                                <small class="text-muted">Creat: {{ apt.created_at }}</small>
                                <small class="text-muted ms-2" *ngIf="apt.cancel_date">| Anulat: {{ apt.cancel_date }}</small>
                            </div>
                        </div>

                        <!-- Paginare trecute -->
                        <div class="pagination-controls" *ngIf="pastTotalPages > 1">
                            <button class="btn btn-sm btn-outline-secondary" (click)="prevPastPage()" [disabled]="pastPage === 0">
                                <i class="fa-solid fa-chevron-left"></i>
                            </button>
                            <span class="page-indicator">{{ pastPage + 1 }} / {{ pastTotalPages }}</span>
                            <button class="btn btn-sm btn-outline-secondary" (click)="nextPastPage()" [disabled]="pastPage >= pastTotalPages - 1">
                                <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
